import React, { useContext } from "react";

import SelectControl from "../SelecControl/SelectControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import './CategoriasRRHHSubtabla.css';
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex";

const CategoriasRRHHSubtabla = ({categorias,handleChangeCategorias,handleDeleteCategoria,tablaSeleccionada, modo}) => {

    const cContext = useContext(categoriasRRHHContext);
    const {categoriasRRHHList} = cContext;
    
    const optionsCategorias = (categoriasRRHHList != undefined) ? categoriasRRHHList.map(c => ({label:c.descrp,value:c.codigo,id:c._id})) : []; 
    
    return <div className={`${tablaSeleccionada != 'catsRRHH' && 'inactive'} categoriasDiv`}>
        <div className={`headerSubtabla`}>
            <label></label>
            <label>Categoria RRHH</label>
            <label>Cantidad en Horas</label>
            <label>Texto Adicional</label>
        </div>
        <div className="bodyTable">
            {categorias.map((c, i) => <div className="rrCategoriasAsociadas" key={i}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteCategoria(c,i)} />
                <SelectControl placeholder={"Seleccione una tarea..."} modo={"Nuevo"} handleChengeSelect={handleChangeCategorias} optionsSelect={optionsCategorias} valueSeleccionada={c.categoria} tipo={'categoriaRRHH'} propToChange="categoria"  selectSelect={handleChangeCategorias} index={i}/>
                <input value={c.cantHoras} onChange={(e) => handleChangeCategorias({},i,'cantHoras',e.target.value)} type="number"/>
                <input value={c.textAdic} onChange={(e) => handleChangeCategorias({},i,'textAdic',e.target.value)}/>
            </div>)}
        </div>
    </div>

}

export default CategoriasRRHHSubtabla;